export default __webpack_public_path__ + "images/twitter-450262ee7a74e4f42cc5b54b4fc7d9a0.svg";